import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {isPast, parse} from "date-fns";

import * as actionTypes from "../../store/actions/actionTypes";
import * as mainActions from "../../store/actions/main";
import * as modalActions from "../../store/actions/modal";
import {useToasts} from "react-toast-notifications";
import {webPasTerm} from "../CustomLogic/Terms";

const canRunOecForAdmission = admission => {
    const _date = parse(admission.admissionDate, 'dd/MM/yyyy', new Date());
    _date.setHours(23, 59, 59);
    const oec_pastAdmissionsManualCheck = admission.hospital && admission.hospital.oec_pastAdmissionsManualCheck;
    return !isPast(_date) || oec_pastAdmissionsManualCheck;
}

const AdmissionList_Bulk = () => {
    const {checkedAdmissions} = useSelector(state => state.bulk.admissionList);
    const admissions = useSelector(state => state.admissionList.admissions);
    const dispatch = useDispatch();
    const {addToast} = useToasts();
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const {demo} = useSelector(state => state.auth);

    const selectAction = (event) => {
        dispatch({type: actionTypes.ADMISSIONS_LIST_BULK_UNSELECT_ALL});
        switch(event.target.value) {
            case "webpas-sync":
                admissions.forEach(admission => {
                    if (checkedAdmissions.includes(admission.id)) {
                        dispatch(mainActions.webPasSync(admission));
                    }
                });
                addToast(`Bulk ${webPasTerm(selectedHospital)} Sync for ${checkedAdmissions.length} patients successfully initiated`, {
                    appearance: 'success',
                    autoDismiss: true
                });
                break;
            case "oec":
                let oecScheduledCount = 0;
                let oecSkippedCount = 0;
                admissions.forEach(admission => {
                    if (checkedAdmissions.includes(admission.id)) {
                        if (canRunOecForAdmission(admission)) {
                            dispatch(modalActions.requestOecCheck(admission))
                            oecScheduledCount++;
                        } else {
                            oecSkippedCount++;
                        }
                    }
                });
                addToast(`Bulk OEC Check for ${oecScheduledCount} patients successfully initiated`, {
                    appearance: 'success',
                    autoDismiss: true
                });
                if (oecSkippedCount > 0) {
                    addToast(`${oecSkippedCount} past admission(s) skipped - OEC check for past admissions is not enabled`, {
                        appearance: 'warning',
                        autoDismiss: true
                    });
                }
                break;
            case "clone-to-today":
                admissions.forEach(admission => {
                    if (checkedAdmissions.includes(admission.id)) {
                        dispatch(mainActions.cloneToToday(admission, addToast));
                    }
                });
                addToast(`Bulk clone to today for ${checkedAdmissions.length} admissions successfully initiated`, {
                    appearance: 'success',
                    autoDismiss: true
                });
                break;
            case "clone-to-tomorrow":
                admissions.forEach(admission => {
                    if (checkedAdmissions.includes(admission.id)) {
                        dispatch(mainActions.cloneToTomorrow(admission, addToast));
                    }
                });
                addToast(`Bulk clone to tomorrow for ${checkedAdmissions.length} admissions successfully initiated`, {
                    appearance: 'success',
                    autoDismiss: true
                });
                break;
        }
    }

    const isDemoHospital = () => {
        return demo && demo.demoHospital && (demo.demoHospital.id === selectedHospital.id);
    };

    const renderFirstOption = () => {
        if (checkedAdmissions.length === 1) {
            return <option value=''>Select bulk action for 1 admission</option>;
        } else if (checkedAdmissions.length > 1) {
            return <option value=''>{`Select bulk action for ${checkedAdmissions.length} admissions`}</option>;
        }
        return <option value=''>Select admissions for bulk action</option>;
    }

    return (<>
        <div className="col-3 mt-2">
            <select className="custom-select" id="inputGroupSelect01" onChange={selectAction}
                    disabled={!checkedAdmissions.length} value=''>
                {renderFirstOption()}
                {selectedHospital.manager_syncAdmission_enable && <option value="webpas-sync">{webPasTerm(selectedHospital)} sync</option>}
                <option value="oec">Check OEC</option>
                {isDemoHospital() && <option value="clone-to-today">Clone to the same day</option>}
                {isDemoHospital() && <option value="clone-to-tomorrow">Clone to next day</option>}
            </select>
        </div>
        <div className="col-9"/>
    </>);
}

export default AdmissionList_Bulk;